import React from "react";
import { DeviceGridCellTemplate } from "themes/application/device-settings/components";

function DeviceGridCell(props) {
    return <DeviceGridCellTemplate {...props} />;
}

export default DeviceGridCell;
